import React from 'react';
import { SeasonalActivity } from './SeasonalActivity';
import { IconHeader, ValidFromTo } from './Dialog';
import { Date } from '../Icons/CustomIcons';

const ValiditySection = ({
  isSeasonal,
  onIsSeasonalChange,
  validFrom,
  onValidFromChange,
  validUntil,
  onValidUntilChange,
}) => {
  return (
    <div className="validity-section">

      <IconHeader Icon={<Date size={20} color="#fff" />}>
        Daten
      </IconHeader>

      <SeasonalActivity
        checked={isSeasonal}
        onCheckedChange={onIsSeasonalChange}
        showFieldInfo
        fieldInfoText={"Wenn angeklickt, gelten die Öffnungszeiten nur für eine Saison. Jährliches Update erforderlich."}
      />

      <div className="validity-dates">
        <div className="validity-field">
          <label className="body Font-M-I-130-T Colors-Black validity-label">Gültig ab (optional)</label>
          <input
            type="date"
            value={validFrom}
            onChange={(e) => onValidFromChange(e.target.value)}
            className="input"
          />
        </div>
        <div className="validity-field">
          <label className="body Font-M-I-130-T Colors-Black validity-label">Gültig bis (optional)</label>
          <input
            type="date"
            value={validUntil}
            onChange={(e) => onValidUntilChange(e.target.value)}
            className="input"
          />
        </div>
      </div>
    </div>
  );
};

export default ValiditySection;

export const AccessibleSection = ({
  isSeasonal,
  onIsSeasonalChange,
  labelFrom,
  labelUntil,
  validFrom,
  validUntil,
  onValidFromChange,
  onValidUntilChange,
  fromRequired = false,
}) => {
  console.log('[AccessibleSection] fromRequired:', fromRequired);
  return (
    <div className="validity-section">
      <IconHeader Icon={<Date size={20} color="#fff" />}>
        Daten
      </IconHeader>

      <SeasonalActivity
        checked={isSeasonal}
        onCheckedChange={onIsSeasonalChange}
        showFieldInfo
        fieldInfoText={"Wenn angeklickt, gelten die Öffnungszeiten nur für eine Saison. Jährliches Update erforderlich."}
      />

      <ValidFromTo
        validFrom={validFrom}
        validUntil={validUntil}
        onChangeFrom={onValidFromChange}
        onChangeUntil={onValidUntilChange}
        fromRequired={fromRequired}
        labelFrom={labelFrom}
        labelUntil={labelUntil}
      />
    </div>
  );
};
